import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtText from "../../../components/NtText";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyAyaya(props) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={
        "NT Connect Partners with Avaya to Deliver Secure Unified Communications for Government"
      }
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Overview</NtCaseStudyTextBold>
        {"\n\n"} NT Connect Holdings, Inc., a leader in communication
        intelligence and IT solutions, has joined the{" "}
        <NtCaseStudyTextBold>Avaya Edge Partner Program</NtCaseStudyTextBold> to
        provide its advanced unified communications platform through{" "}
        <NtCaseStudyTextBold>
          Avaya’s FedRAMP-authorized Government Cloud.
        </NtCaseStudyTextBold>{" "}
        This strategic collaboration enhances NT Connect’s ability to serve U.S.
        federal agencies with a secure, scalable, and fully integrated
        communication solution.{"\n\n"}
        <NtCaseStudyTextBold>Challenge</NtCaseStudyTextBold>
        {"\n\n"}Government agencies require robust and compliant communication
        systems that ensure security, flexibility, and reliability. However,
        modernizing legacy systems while meeting strict federal standards like
        FedRAMP presents a significant challenge. NT Connect aimed to deliver a
        next-generation unified communications platform tailored to the needs of
        the public sector, but doing so required a highly secure,
        government-compliant cloud infrastructure.{"\n\n"}
        <NtCaseStudyTextBold>Solution</NtCaseStudyTextBold>
        {"\n\n"}To overcome this challenge, NT Connect partnered with Avaya and
        joined the Avaya Edge Partner Program, enabling it to deploy its unified
        communications platform within the Avaya Government Cloud, a
        FedRAMP-authorized environment purpose-built for public sector needs
        {"\n\n"}Through this partnership, NT Connect’s unified communications
        system, featuring real-time voice, video, messaging, conferencing, and
        mobility, is now seamlessly integrated into a cloud platform that meets
        federal cybersecurity and compliance standards.
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{ marginTop: 20, margigRignt: 30, marginLeft: 30 }}
      >
        “Partnering with Avaya’s Gov Cloud is a transformative step in our
        mission to deliver secure, efficient, and scalable communication
        solutions to government entities,”{"\n"}
        <NtText style={{ fontStyle: "italic" }}>
          – Garry Paxinos, Chief Technology Officer and Chief Artificial
          Intelligence Officer, NT Connect
        </NtText>
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Impact</NtCaseStudyTextBold>
        {"\n\n"}
        By leveraging Avaya’s secure cloud infrastructure, NT Connect now
        provides government agencies with:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          End-to-end unified communications
        </NtCaseStudyTextBold>{" "}
        in a single platform
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Full compliance</NtCaseStudyTextBold> with federal
        security and operational standards
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Enhanced collaboration</NtCaseStudyTextBold> and
        efficiency for distributed teams
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Seamless scalability</NtCaseStudyTextBold> for
        future growth and modernization
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        This initiative allows public sector clients to modernize their
        communication infrastructure while maintaining the highest levels of
        data protection and service reliability.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyAyaya;
